import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import LinearWithValueLabel from './LinearWithValueLabel';
import ClientProvider from './client';
export default createDemo(import.meta.url, LinearWithValueLabel, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/progress/demos/linear-with-value-label/LinearWithValueLabel.tsx",
    "fileName": "LinearWithValueLabel.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport LinearProgress from '@mui/material/LinearProgress';\nimport type { LinearProgressProps } from '@mui/material/LinearProgress';\nimport Typography from '@mui/material/Typography';\nimport Box from '@mui/material/Box';\n\nfunction LinearProgressWithLabelAndValue(\n  props: LinearProgressProps & { value: number },\n) {\n  const progressId = React.useId();\n  return (\n    <div>\n      <Typography id={progressId} variant=\"body2\" color=\"text.secondary\">\n        Uploading photos…\n      </Typography>\n      <Box sx={{ display: 'flex', alignItems: 'center' }}>\n        <Box sx={{ width: '100%', mr: 1 }}>\n          <LinearProgress\n            variant=\"determinate\"\n            aria-labelledby={progressId}\n            {...props}\n          />\n        </Box>\n        <Box sx={{ minWidth: 35 }}>\n          <Typography variant=\"body2\" sx={{ color: 'text.secondary' }}>\n            {`${Math.round(props.value)}%`}\n          </Typography>\n        </Box>\n      </Box>\n    </div>\n  );\n}\n\nexport default function LinearWithValueLabel() {\n  const [progress, setProgress] = React.useState(10);\n\n  React.useEffect(() => {\n    const timer = setInterval(() => {\n      setProgress((prevProgress) => (prevProgress >= 100 ? 10 : prevProgress + 10));\n    }, 800);\n    return () => {\n      clearInterval(timer);\n    };\n  }, []);\n\n  return (\n    <Box sx={{ width: '100%' }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <LinearProgressWithLabelAndValue value={progress} />\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 51,
        "focusedLines": 1,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport LinearProgress from '@mui/material/LinearProgress';\nimport type { LinearProgressProps } from '@mui/material/LinearProgress';\nimport Typography from '@mui/material/Typography';\nimport Box from '@mui/material/Box';\n\nfunction LinearProgressWithLabelAndValue(\n  props: LinearProgressProps & { value: number },\n) {\n  const progressId = React.useId();\n  return (\n    <div>\n      <Typography id={progressId} variant=\"body2\" color=\"text.secondary\">\n        Uploading photos…\n      </Typography>\n      <Box sx={{ display: 'flex', alignItems: 'center' }}>\n        <Box sx={{ width: '100%', mr: 1 }}>\n          <LinearProgress\n            variant=\"determinate\"\n            aria-labelledby={progressId}\n            {...props}\n          />\n        </Box>\n        <Box sx={{ minWidth: 35 }}>\n          <Typography variant=\"body2\" sx={{ color: 'text.secondary' }}>\n            {`${Math.round(props.value)}%`}\n          </Typography>\n        </Box>\n      </Box>\n    </div>\n  );\n}\n\nexport default function LinearWithValueLabel() {\n  const [progress, setProgress] = React.useState(10);\n\n  React.useEffect(() => {\n    const timer = setInterval(() => {\n      setProgress((prevProgress) => (prevProgress >= 100 ? 10 : prevProgress + 10));\n    }, 800);\n    return () => {\n      clearInterval(timer);\n    };\n  }, []);\n\n  return (\n    <Box sx={{ width: '100%' }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <LinearProgressWithLabelAndValue value={progress} />\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 48
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "LinearProgressWithLabelAndValue"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "value"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "progress"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              " />"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 51,
    "focusedLines": 1,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/LinearProgress",
      "@mui/material/Typography",
      "@mui/material/Box"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
